"use strict";

import angular from "angular";
import core from "../../core.module";
import _ from "lodash";
import components from "./components";
import api from "../api";
import common from "../common";
import { cloudinaryUrl } from "./announcement.directives";

let module = angular
    .module("common.communication", [core, common.name, api.name])
    .directive("cloudinaryUrl", cloudinaryUrl);

_.forEach(components, function (component) {
    module.component(component.name, component);
});

module.config(function ($translateProvider) {
    "ngInject";

    _.forEach(components, function (component) {
        _.forEach(component.translations, function (table, language) {
            $translateProvider.translations(language, table);
        });
    });
});

export default module;
